var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRating3GrayOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9998 1.2063H0.999756V61.2063H60.9998V1.2063Z",
    stroke: "#797979",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2264 21.9247C22.6064 21.9247 24.5358 19.9953 24.5358 17.6153C24.5358 15.2353 22.6064 13.3059 20.2264 13.3059C17.8464 13.3059 15.917 15.2353 15.917 17.6153C15.917 19.9953 17.8464 21.9247 20.2264 21.9247Z",
    fill: "#797979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6077 21.9247C43.9877 21.9247 45.9171 19.9953 45.9171 17.6153C45.9171 15.2353 43.9877 13.3059 41.6077 13.3059C39.2277 13.3059 37.2983 15.2353 37.2983 17.6153C37.2983 19.9953 39.2277 21.9247 41.6077 21.9247Z",
    fill: "#797979"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2539 35.6804C43.2649 41.6473 37.6296 45.9567 30.9997 45.9567C24.3699 45.9567 18.7346 41.6473 16.7456 35.6804",
    stroke: "#797979",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating3GrayOutlined);
export default __webpack_public_path__ + "static/media/rating3-gray-outlined.f9d20d6d233dd85893ad45020db88614.svg";
export { ForwardRef as ReactComponent };